// extracted by mini-css-extract-plugin
export default {"issueTaskCard":"IssueTaskCard_issueTaskCard__cO72L"};